import React from "react";

/**
 * Multident custom mark — a stylized "M" built from two mirrored arches
 * evoking twin teeth / an abstract smile. Monoline, premium, scalable.
 */
export const MultidentMark = ({ size = 28, className = "", color = "currentColor", accent = "#D4AF37" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* Twin arches / M */}
    <path
      d="M8 36V20C8 14.4772 12.4772 10 18 10C21.5 10 23.5 11.8 24 14C24.5 11.8 26.5 10 30 10C35.5228 10 40 14.4772 40 20V36"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
    />
    {/* Center stem */}
    <path d="M24 14V36" stroke={color} strokeWidth="2.4" strokeLinecap="round" />
    {/* Gold accent spark */}
    <circle cx="24" cy="40" r="2.4" fill={accent} />
  </svg>
);

export const MultidentLogo = ({ compact = false, invert = false }) => (
  <span className="inline-flex items-center gap-2.5 select-none">
    <MultidentMark
      size={28}
      color={invert ? "#FFFFFF" : "#1A1A1A"}
      accent="#D4AF37"
    />
    {!compact && (
      <span
        className={`font-display text-[22px] tracking-[-0.02em] leading-none ${
          invert ? "text-white" : "text-[#1A1A1A]"
        }`}
      >
        Multident
      </span>
    )}
  </span>
);
